module.exports = __webpack_public_path__ + "img/52002752_L.03bf8041.png";